if (!customElements.get("pdp-swatch-row")) {
  customElements.define("pdp-swatch-row", class extends HTMLElement {
    connectedCallback() {
      this.swatches = Array.from(this.querySelectorAll(":scope > .pdp-fabric-swatch"));
      this.toggle = this.querySelector(".pdp-swatches-toggle");
      if (!this.swatches.length || !this.toggle) return;

      this.scheduleUpdate = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.onToggle = () => this.openDrawer();
      this.toggle.addEventListener("click", this.onToggle);
      this.addEventListener("change", this.scheduleUpdate);
      window.addEventListener("pdpConfigurationChange", this.scheduleUpdate);
      this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
      this.resizeObserver.observe(this);
      this.scheduleUpdate();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.toggle?.removeEventListener("click", this.onToggle);
      this.removeEventListener("change", this.scheduleUpdate);
      window.removeEventListener("pdpConfigurationChange", this.scheduleUpdate);
      this.drawer?.remove();
      this.drawer = null;
      this.picker = null;
    }

    async openDrawer() {
      await Promise.all([customElements.whenDefined("pdp-swatch-picker"), customElements.whenDefined("drawer-section")]);
      if (!this.isConnected) return;
      if (!this.drawer) {
        const template = this.querySelector("[data-swatch-drawer-template]");
        if (!template) return;
        const fragment = template.content.cloneNode(true);
        this.drawer = fragment.querySelector("drawer-section");
        this.drawer.id = `drawer-swatches-${this.swatches[0].querySelector("input").id}`;
        this.toggle.setAttribute("aria-controls", this.drawer.id);
        document.body.append(fragment);
        this.picker = this.drawer.querySelector("pdp-swatch-picker");
        this.picker.initialize(this);
      }
      this.picker.open();
    }

    update() {
      // Unhide before measuring so resizing also works with a selected last swatch.
      this.swatches.forEach((swatch) => { swatch.hidden = false; });
      const { width, height } = this.swatches[0].getBoundingClientRect();
      const availableWidth = this.getBoundingClientRect().width;
      if (!width || !availableWidth) return;

      const gap = parseFloat(getComputedStyle(this).columnGap) || 0;
      const slots = Math.max(1, Math.floor((availableWidth + gap + 0.5) / (width + gap)));
      const overflowing = this.swatches.length > slots;
      const visibleCount = overflowing ? slots - 1 : this.swatches.length;
      const hiddenCount = this.swatches.length - visibleCount;
      const visible = new Set(this.swatches.slice(0, visibleCount));
      const selected = this.swatches.find((swatch) => swatch.querySelector("input:checked"));
      if (selected && visibleCount > 0 && !visible.has(selected)) {
        visible.delete(this.swatches[visibleCount - 1]);
        visible.add(selected);
      }

      this.swatches.forEach((swatch) => {
        swatch.hidden = !visible.has(swatch);
      });
      this.style.setProperty("--swatch-toggle-width", `${width}px`);
      this.style.setProperty("--swatch-toggle-height", `${height}px`);
      this.toggle.hidden = !overflowing;
      this.toggle.setAttribute("aria-label", `${this.toggle.dataset.expandLabel} (+${hiddenCount})`);
      this.toggle.querySelector("[data-swatches-toggle-count]").textContent = String(hiddenCount);
      this.setAttribute("data-ready", "");
      this.picker?.sync();
    }
  });
}
